// plugins/engine.js
import enigma from 'enigma.js'
import { logger } from '~/utils/logger'

async function establishQPSSession(FullQlikPublicUrl) {
  if (!FullQlikPublicUrl || !FullQlikPublicUrl.startsWith('http')) {
    logger.error(
      'Invalid FullQlikPublicUrl - must include https://',
      FullQlikPublicUrl
    )
    return
  }
  try {
    logger.debug('Fetching user info from:', FullQlikPublicUrl)
    await fetch(`${FullQlikPublicUrl}/qps/user`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'X-Qlik-Xrfkey': 'abcdefghijklmnop',
        'Content-Type': 'application/json'
      }
    })
  } catch (e) {
    logger.warn('QPS pre-auth failed:', e)
  }
}

async function startSession({ app, $config }) {
  const qix = app.$qix //.getQIXConfig({ env: app.$env })
  logger.debug('QIX config:', qix)

  await establishQPSSession($config.FullQlikPublicUrl)

  const global = await enigma.create(qix).open()
  const app_session = await global.openDoc(qix.appId)
  return await app_session
}

export default async ({ app, $config }, inject) => {
  if (!process.client) return
  //console.debug('server ', process.server, 'client ', process.client)
  logger.debug('app.$qix on client:', app.$qix)
  const appSession = await startSession({ app, $config })
  logger.debug('engine.js session', appSession)
  //console.debug('server ', process.server, 'client ', process.client)
  inject('qix_session', appSession)
}
